import {atom} from "nanostores"

export const $error = atom("")